import { AirValidationSector } from '@app/entities/air-validation.response';
import { FlightItem } from '@app/entities/flight-results';

export function flightItemMapper(sector: AirValidationSector): FlightItem {
  const flightsLength = sector.Flights.length;
  return {
    ...sector,
    DepartureAirport: sector.Flights[0].DepartureAirport,
    ArrivalAirport: sector.Flights[flightsLength - 1].ArrivalAirport,
    AirlineCode: sector.Flights[0].AirlineCode,
    AirlineName: sector.Flights[0].AirlineName,
    DepartureDate: sector.Flights[0].DepartureDate,
    ArrivalDate: sector.Flights[flightsLength - 1].ArrivalDate,
    SectorNumber: sector.SectorNumber
  }
}
